export default __webpack_public_path__ + "static/media/social-proof.b32e00aa.png";